import React from 'react';
import { Container } from 'react-bootstrap';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

const data = [
  { range: '$147K', share: 2 },
  { range: '$188K', share: 4 },
  { range: '$226K', share: 6 },
  { range: '$253K', share: 8 },
  { range: '$274K', share: 9 },
  { range: '$309K', share: 12, highlight: true }, // Highlighted bar
  { range: '$344K', share: 14 },
  { range: '$381K', share: 12 },
  { range: '$425K', share: 10 },
  { range: '$459K', share: 8 },
  { range: '$494K', share: 6 },
  { range: '$546K', share: 4 },
  { range: '$605K', share: 2 },
  { range: '$675K', share: 1 },
  { range: '$1.27M', share: 1 },
];

const HomeValuesChart = () => {
  return (
    <Container className="mt-4">
      <h3>Home Values in Elgin</h3>
      <div className="text-muted mb-2" style={{ borderBottom: '2px solid #f57921', width: '60px' }}>
        Values
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <XAxis dataKey="range" angle={-45} textAnchor="end" interval={0} height={60} />
          <YAxis domain={[0, 15]} tickFormatter={(tick) => `${tick}%`} />
          <Tooltip formatter={(value) => `${value}% Market Share`} />
          <Bar dataKey="share">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.highlight ? '#f57921' : '#003A78'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default HomeValuesChart;